/* eslint-disable import/no-cycle */
import client from 'client';
import { sessionProvider } from 'utils';
import OrganizationActionTypes from '../types/organization';
import BrandingActionTypes from '../types/branding';

export const fetchOrganization = () => async (dispatch) => {
  if (sessionProvider.isAuthenticated()) {
    try {
      await dispatch({
        type: OrganizationActionTypes.LOAD_ORGANIZATION_REQUEST,
      });
      const { data } = await client.get('/apis/v2/organizations/current');
      await dispatch({
        type: OrganizationActionTypes.LOAD_ORGANIZATION_SUCCESS,
        payload: { data: data?.data },
      });
      await dispatch({
        type: BrandingActionTypes.LOAD_BRANDING_SUCCESS,
        payload: {
          data:
            {
              displayName: data?.data.attributes.displayName,
              logo: data?.data.attributes.logoUrl,
              icon: data?.data.attributes.logoSmallUrl,
              whiteIcon: data?.data.attributes.whiteLogoSmallUrl,
              whiteLogo: data?.data.attributes.whiteLogoUrl,
              primary: data?.data.attributes.branding.primary,
              secondary: data?.data.attributes.branding.secondary,
              sidebar: data?.data.attributes.branding.sidebar,
              sidebarNested: data?.data.attributes.branding.sidebarNested,
              sidebarSelect: data?.data.attributes.branding.sidebarSelect,
            } || {},
        },
      });
    } catch (error) {
      await dispatch({
        type: OrganizationActionTypes.LOAD_ORGANIZATION_FAILURE,
        error,
      });
    }
  }
};

export const fetchOrganizationById = (id) => async (dispatch) => {
  if (id) {
    try {
      await dispatch({
        type: OrganizationActionTypes.LOAD_ORGANIZATION_REQUEST,
      });
      const { data } = await client.get(`/apis/v2/organizations_public/${id}`);
      await dispatch({
        type: OrganizationActionTypes.LOAD_ORGANIZATION_SUCCESS,
        payload: { data: data?.data },
      });
    } catch (error) {
      await dispatch({
        type: OrganizationActionTypes.LOAD_ORGANIZATION_FAILURE,
        error,
      });
    }
  }
};
